import CIcon from '@coreui/icons-react';
import { CButton, CCol, CForm, CRow } from '@coreui/react';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { setFlexibleModal, setRuleHaveEditting } from '../../../../../../actions/common';
import { setNewLayout, setShowBlockAccountPopup, setSubscriberState, setUnsavedLookupTableModal, setUsedItems } from '../../../../../../actions/subscriber';
import { callTokenApi } from '../../../../../../apiCaller';
import {
     API_CLIENT_RULE,
     API_CLIENT_RULE_ADD,
     API_CLIENT_RULE_REVERT,
     API_CLIENT_RULE_UPDATE,
     COMPONENT_NAME,
     REGEX_PATTERNS,
     TYPE_SHOW_UNSAVE_CHANGE,
} from '../../../../../../constants';
import { subscriberNavKey } from '../../../../../../containers/_nav/subscriber';
import { deepCopyArray, toastError, useOutsideHandling } from '../../../../../../utils';
import CenterSpinner from '../../../../../general/Loadings/CenterSpinner';
import { ConfirmRemovePopup, ConfirmSaveChange, LeaveComponentChangePopup } from '../../../../../general/popup';
import RemovePopup from '../../../../../general/popup/RemovePopup';
import CLabel from '../../../../../migration/CLabel';

export const RuleTableContext = React.createContext({});

const FormRuleTableBase = ({
     variant,
     stepsData,
     setStepsData,
     initialStepsData,
     isCreateMode,
     rulesStateKey,
     selectedListenerRule,
     fetchLoading,
     validateFn,
     onRevertSuccess,
     TableHeaderRow,
     TableBodyRows,
     ImportExportTable,
     extraBodyContext,
     extraImportContext,
     btnSaveStatusInitial,
     scrollThreshold,
}) => {
     const wrapperRef = useRef(null);
     const observedElementsRef = useRef([]);
     const history = useHistory();
     const dispatch = useDispatch();
     const activeAccount = useSelector((state) => state.subscriber.activeAccount);
     const flexibleModal = useSelector((state) => state.theme.flexibleModal);
     const unsavedLookupTableModal = useSelector((state) => state.subscriber.unsavedLookupTableModal);
     const rules = useSelector((state) => state.subscriber[rulesStateKey]);

     const [saveLoading, setSaveLoading] = useState(false);
     const [deleteRuleModal, setDeleteRuleModal] = useState(false);
     const [saveTableModal, setSaveTableModal] = useState(false);
     const [revertModal, setRevertModal] = useState(false);
     const [leaveComponentModal, setLeaveComponentModal] = useState(false);
     const [navigateTo, setNavigateTo] = useState();
     const [btnSaveStatus, setBtnSaveStatus] = useState(btnSaveStatusInitial);
     const [removeRowModal, setRemoveRowModal] = useState({ show: false, index: -1 });
     const [deleteLoading, setDeleteLoading] = useState(false);
     const [tableRow, setTableRow] = useState();
     const [showCheatSheet, setShowCheatSheet] = useState(false);
     const [btnAbandon, setBtnAbandon] = useState(false);

     const { id: accountId, numberOfCusVariablesRules } = activeAccount;
     const conditions = stepsData?.conditions;
     const isRuleEdit = variant === 'rule-edit' ;
     const onlyView = isRuleEdit && stepsData?.name === 'Categorize Forms';

     const defaultRow = () => {
          const initialConditions = conditions[0].map((item) => {
               const key = item.g0.key;
               const value = variant === 'crawl-block' && key === 'Match Type' ? 'formId' : '';
               return {
                    conjunction: item.conjunction,
                    g0: { type: item.g0.type, id: item.g0.id, key, operator: item.g0.operator, value, isRegex: false },
               };
          });
          return { conditions: [...initialConditions], customVariables: [{ id: '', formName: '' }] };
     };

     const getInitialTableRow = () => {
          let table = [];
          const conditionData = conditions.map((item) => item);
          const customVariableData = stepsData.customVariables ? stepsData.customVariables.map((item) => item) : [];

          for (let i = 0; i < conditionData.length; i++) {
               const row = { conditions: conditionData[i] };
               if (customVariableData[i]) row.customVariables = customVariableData[i];
               table.push(row);
          }

          const newTable = [...table].sort((a, b) => {
               if (a.conditions[0].g0.value === '(.*?)') return 1;
               if (a.conditions[0].g0.value < b.conditions[0].g0.value) return -1;
               if (a.conditions[0].g0.value > b.conditions[0].g0.value) return 1;
               if (a.conditions[1]) {
                    if (a.conditions[1].g0.value.length < b.conditions[1].g0.value.length) return 1;
                    if (a.conditions[1].g0.value.length > b.conditions[1].g0.value.length) return -1;
               }
               return 0;
          });

          setTableRow(newTable);
     };

     useEffect(getInitialTableRow, []); // eslint-disable-line

     const beforeunload = (e) => {
          e.preventDefault();
          e.returnValue = '';
     };

     useEffect(() => {
          dispatch(setUnsavedLookupTableModal({ unsaved: false }));

          const unblock = history.block((location) => {
               const url = location.pathname;
               if (!btnSaveStatus) {
                    setBtnSaveStatus(true);
                    setNavigateTo(url);
                    setLeaveComponentModal(true);
                    return false;
               }
               return true;
          });

          if (!btnSaveStatus) {
               document.querySelector('.flexible-modal-body').addEventListener('beforeunload', beforeunload);
          }

          return () => {
               document.querySelector('.flexible-modal-body').removeEventListener('beforeunload', beforeunload);
               unblock();
          };
     }, [btnSaveStatus, history, dispatch]);

     const handleAcceptLeaveComponent = () => {
          if (unsavedLookupTableModal.show) {
               const conditionsCopy = JSON.parse(JSON.stringify(initialStepsData.conditions));
               const customVariablesCopy = JSON.parse(JSON.stringify(initialStepsData.customVariables));
               let table = [];
               const conditionData = conditionsCopy.map((item) => item);
               const customVariableData = customVariablesCopy.map((item) => item);
               for (let i = 0; i < conditionData.length; i++) {
                    table.push({ conditions: conditionData[i], customVariables: customVariableData[i] });
               }
               setTableRow(table);
               setBtnSaveStatus(true);
               unsavedLookupTableModal.onAccept();
               dispatch(setUnsavedLookupTableModal({ show: false, onAccept: null }));
          } else {
               setBtnAbandon(true);
               window.location.href = navigateTo;
          }
     };

     const handleCloseLeaveComponent = () => {
          setLeaveComponentModal(false);
          setBtnSaveStatus(false);
          dispatch(setUnsavedLookupTableModal({ show: false }));
          dispatch(setNewLayout({ activeMainNavItem: subscriberNavKey.LISTENERS }));
     };

     const handleAddRow = (rows = 1) => {
          const newTableRow = [...tableRow];
          for (let i = 0; i < rows; i++) {
               const newRow = defaultRow();
               const conjunctions = tableRow[0].conditions.map((item) => item.conjunction);
               newRow.conditions.forEach((item, index) => {
                    item.conjunction = conjunctions[index];
               });
               newTableRow.push(newRow);
          }
          setTableRow(newTableRow);
          resetBtnSaveStatus();
     };

     const handleSelectOperator = (evt, colIndex) => {
          const { value, name } = evt.target;
          const fields = [...conditions];
          const table = deepCopyArray(tableRow);

          if (name === 'operator') {
               fields[0][colIndex].g0.operator = value;
               table.forEach((row) => {
                    row.conditions[colIndex].g0.operator = value;
               });
          } else {
               fields[0][colIndex].conjunction = value;
               table.forEach((row) => {
                    row.conditions[colIndex].conjunction = value;
               });
          }
          setTableRow(table);
          setStepsData({ ...stepsData, conditions: fields });
          resetBtnSaveStatus();
     };

     const confirmRemoveRow = () => {
          let data = [...tableRow];
          const { index } = removeRowModal;
          if (data.length > 1) data.splice(index, 1);
          else data = [defaultRow()];
          setTableRow(data);
          setRemoveRowModal({ show: false, index: -1 });
          resetBtnSaveStatus();
     };

     const handleDelete = () => {
          setDeleteLoading(true);
          callTokenApi(`${API_CLIENT_RULE}${stepsData.id}`, 'DELETE').then((response) => {
               if (response.status === 200) {
                    dispatch(setUsedItems({ itemName: 'numberOfCusVariablesRules', quantity: numberOfCusVariablesRules - 1 }));
                    setBtnSaveStatus(true);
                    if (rules) {
                         dispatch(setSubscriberState({ [rulesStateKey]: rules.filter((r) => r.id !== stepsData.id) }));
                    }
                    dispatch(setRuleHaveEditting({ show: false, type: '', showLv2: false, typeLv2: '' }));
                    dispatch(setFlexibleModal({ show: false, showLv2: false, ruleId: null, ruleIdLv2: null, component: '', componentLv2: '' }));
               } else if (response.data.accountBlocked) {
                    dispatch(setShowBlockAccountPopup(true));
               } else {
                    toastError(response);
               }
          });
     };

     const createNewRule = () => {
          const newStepsData = { ...stepsData };
          const newConditions = [];
          tableRow.forEach((row) => {
               const newConditionRow = [];
               row.conditions.forEach((condition, index) => {
                    if (index === conditions[0].length - 1) condition.conjunction = '';
                    newConditionRow.push(condition);
               });
               newConditions.push(newConditionRow);
          });
          newStepsData.conditions = newConditions;
          const payload = { accountId, listenerId: selectedListenerRule, ...newStepsData };

          setBtnSaveStatus(true);
          callTokenApi(API_CLIENT_RULE_ADD, 'POST', payload)
               .then((response) => {
                    if (response.status !== 200) {
                         if (response.data.accountBlocked) dispatch(setShowBlockAccountPopup(true));
                         else toastError(response);
                         return;
                    }
                    const newRules = [...rules];
                    newRules.push(response.data.rule);
                    dispatch(setSubscriberState({ [rulesStateKey]: newRules }));
                    dispatch(setRuleHaveEditting({ show: false, type: '', showLv2: false, typeLv2: '' }));
                    dispatch(setFlexibleModal({ show: false, showLv2: false, ruleId: null, ruleIdLv2: null, component: '', componentLv2: '' }));
               })
               .finally(() => {
                    setBtnSaveStatus(false);
               });
     };

     const onSubmit = (e) => {
          e.preventDefault();
          const error = validateFn(tableRow);
          if (error.key !== '') {
               const msg = isRuleEdit && error.type !== 'Event' ? `${error.key} cannot be empty.` : `${error.key} is required.`;
               toast.error(msg);
               return;
          }
          if (isCreateMode) createNewRule();
          else setSaveTableModal(true);
     };

     const onAcceptSaveModal = () => {
          const data = { ...stepsData };
          const newConditions = [];
          const newCustomVariables = [];

          tableRow.forEach((row) => {
               const newConditionRow = [];
               row.conditions.forEach((condition, index) => {
                    if (index === conditions[0].length - 1) condition.conjunction = '';
                    newConditionRow.push(condition);
               });

               if (isRuleEdit && row.customVariables && Array.isArray(row.customVariables)) {
                    row.customVariables.forEach((variable) => {
                         if (variable.formName) variable.formName = variable.formName.trim();
                    });
                    newCustomVariables.push(row.customVariables);
               }

               newConditions.push(newConditionRow);
          });

          data.conditions = newConditions;
          if (isRuleEdit) data.customVariables = newCustomVariables;

          setTableRow([...tableRow]);
          handleSaveLookupTable({
               id: data.id,
               accountId: data.accountId,
               listenerId: data.listenerId,
               conditions: data.conditions,
               customVariables: data.customVariables,
               type: data.type,
               name: data.name,
               description: data.description,
          });
          setBtnSaveStatus(true);
     };

     const handleSaveLookupTable = (data) => {
          setSaveLoading(true);
          callTokenApi(API_CLIENT_RULE_UPDATE, 'POST', data)
               .then((response) => {
                    if (response.status === 200) {
                         setSaveTableModal(false);
                         dispatch(setRuleHaveEditting({ show: false, type: '', showLv2: false, typeLv2: '' }));
                         dispatch(setFlexibleModal({ show: false, showLv2: false }));
                         return;
                    }
                    if (response.data.accountBlocked) dispatch(setShowBlockAccountPopup(true));
                    else toastError(response);
               })
               .finally(() => {
                    setSaveLoading(false);
               });
     };

     const handleReverting = () => {
          const payload = { accountId, ruleId: stepsData.id };
          setSaveLoading(true);
          callTokenApi(API_CLIENT_RULE_REVERT, 'POST', payload)
               .then((response) => {
                    if (response.status === 200) {
                         onRevertSuccess(dispatch, setStepsData);
                    } else if (response.data.accountBlocked) {
                         dispatch(setShowBlockAccountPopup(true));
                    } else {
                         toastError(response);
                    }
               })
               .finally(() => {
                    setSaveLoading(false);
                    setRevertModal(false);
                    dispatch(setRuleHaveEditting({ show: false, type: '', showLv2: false, typeLv2: '' }));
               });
     };

     const resetBtnSaveStatus = useCallback(() => {
          if (btnSaveStatus === true) setBtnSaveStatus(false);
          dispatch(setRuleHaveEditting({ show: true, type: TYPE_SHOW_UNSAVE_CHANGE.EDIT_TABLE }));
     }, [btnSaveStatus, dispatch]);

     const onDragEnd = (result) => {
          if (!result.destination || result.destination.index === result.source.index) return;
          const rows = reorder(tableRow, result.source.index, result.destination.index);
          resetBtnSaveStatus();
          setTableRow(rows);
     };

     const reorder = (list, startIndex, endIndex) => {
          const result = Array.from(list);
          const [removed] = result.splice(startIndex, 1);
          result.splice(endIndex, 0, removed);
          return result;
     };

     const handleChangeRowData = (value, arrayName, rowIndex, colIndex) => {
          setTableRow((prevTableRow) => {
               const data = deepCopyArray(prevTableRow);
               if (arrayName === 'conditions') {
                    data[rowIndex].conditions[colIndex].g0.value = value;
               } else if (arrayName === 'formCategory') {
                    data[rowIndex].customVariables[colIndex].id = value;
               } else if (arrayName === 'formName') {
                    data[rowIndex].customVariables[colIndex].formName = value;
               }
               return data;
          });
          resetBtnSaveStatus();
     };

     const handleClickEditButton = (id) => {
          dispatch(
               setFlexibleModal({
                    show: true,
                    showLv2: true,
                    ruleId: id,
                    ruleIdLv2: id,
                    component: COMPONENT_NAME.FORM_RULE_TABLE,
                    componentLv2: COMPONENT_NAME.FORM_RULE_SETTING,
               }),
          );
          dispatch(setRuleHaveEditting({ showLv2: false, typeLv2: '' }));
     };

     const handleClickCheatSheet = useCallback(() => {
          setTimeout(() => {
               setShowCheatSheet(!showCheatSheet);
          }, 100);
     }, [showCheatSheet]);

     const handleClickOutside = useCallback(() => {
          setShowCheatSheet(false);
     }, []);
     useOutsideHandling(wrapperRef, handleClickOutside);

     useEffect(() => {
          let header = document.querySelectorAll('.flexible-modal-header');
          let body = document.querySelectorAll('.flexible-modal-body');
          const observedElements = document.querySelectorAll('.ll-flexible-modal');
          const table = document.querySelector('.lookup-table-init');
          const stickyTable = document.querySelector('.lookup-table-sticky');

          if (header.length > 0) header = header[!flexibleModal.showLv2 ? 0 : 1];
          if (body.length > 0) body = body[!flexibleModal.showLv2 ? 0 : 1];

          let headerHeight = header.offsetHeight;

          const handleResize = () => {
               const tableHeaderTop = table?.offsetTop || 0;
               const headerBottom = headerHeight + body.scrollTop;
               const tableHeader = table?.childNodes?.[0] || null;
               const tableHeader2ndRow = tableHeader?.childNodes?.[1] || null;
               const tableHeaderColumns = tableHeader2ndRow?.childNodes || [];
               const stickyTableHeader = stickyTable?.childNodes?.[0];
               headerHeight = header.offsetHeight;

               const updateStickyTable = () => {
                    if (!stickyTable) return;
                    stickyTable.style.width = table.parentNode.offsetWidth + 'px';
                    stickyTable.style.top = headerHeight + 'px';
                    for (let i = 0; i < tableHeaderColumns?.length; i++) {
                         stickyTableHeader.childNodes[1].childNodes[i].style.width = tableHeaderColumns[i].offsetWidth + 'px';
                         stickyTableHeader.childNodes[2].childNodes[i].style.width = tableHeaderColumns[i].offsetWidth + 'px';
                    }
               };

               if (headerBottom > tableHeaderTop + 10) {
                    if (window.screen.width === 991) {
                         setTimeout(() => updateStickyTable(), 600);
                    } else {
                         updateStickyTable();
                    }
               }
          };

          let modalBody = document.querySelectorAll('.flexible-modal-body');
          if (modalBody.length > 0) modalBody = modalBody[!flexibleModal.showLv2 ? 0 : 1];

          const handleScroll = () => {
               const tableHeaderTop = table?.offsetTop || 0;
               const headerBottom = headerHeight + body.scrollTop;
               const tableHeader = table?.childNodes?.[0] || null;
               const tableHeader2ndRow = tableHeader?.childNodes?.[1] || null;
               const tableHeaderColumns = tableHeader2ndRow?.childNodes || [];
               const stickyTableHeader = stickyTable.childNodes[0];

               if (headerBottom > tableHeaderTop + scrollThreshold) {
                    tableHeader.style.visibility = 'hidden';
                    stickyTable.style.display = 'block';
                    stickyTable.style.width = table.parentNode.offsetWidth + 'px';
                    stickyTable.style.top = headerHeight + 'px';
                    for (let i = 0; i < tableHeaderColumns.length; i++) {
                         stickyTableHeader.childNodes[1].childNodes[i].style.width = tableHeaderColumns[i].offsetWidth + 'px';
                         stickyTableHeader.childNodes[2].childNodes[i].style.width = tableHeaderColumns[i].offsetWidth + 'px';
                    }
               } else {
                    table.children[0].style.visibility = 'visible';
                    stickyTable.style.display = 'none';
               }
          };

          modalBody.addEventListener('scroll', handleScroll);
          const resizeObserver = new ResizeObserver((entries) => {
               entries.forEach(() => handleResize());
          });
          observedElements.forEach((element) => resizeObserver.observe(element));
          observedElementsRef.current = Array.from(observedElements);
          return () => {
               resizeObserver.disconnect();
               modalBody.removeEventListener('scroll', handleScroll);
          };
     }, []); // eslint-disable-line react-hooks/exhaustive-deps

     const handleScrollTableWrapper = (e) => {
          const stickyTable = document.querySelector('.lookup-table-sticky');
          stickyTable.scrollLeft = e.target.scrollLeft;
     };

     const headerRowContext = { conditions, handleSelectOperator };
     const bodyRowContext = {
          isCreateMode,
          tableRow,
          setTableRow,
          resetBtnSaveStatus,
          setRemoveRowModal,
          handleChangeRowData,
          onlyView,
          ...extraBodyContext,
     };
     const importExportContext = useMemo(
          () => ({
               tableRow,
               setTableRow,
               setBtnSaveStatus,
               resetBtnSaveStatus,
               ...extraImportContext,
               // eslint-disable-next-line react-hooks/exhaustive-deps
          }),
          [tableRow, setBtnSaveStatus, resetBtnSaveStatus, extraImportContext],
     );

     const condColSpan = conditions?.length > 0 ? conditions[0].length : 3;

     return (
          <>
               <CForm className='form-edit-lookup' onSubmit={onSubmit}>
                    {isRuleEdit && (
                         <CRow>
                              <CCol md='12' className='form-edit-lookup-row'>
                                   <div className='form-edit-lookup-title'>
                                        <h1 className='d-flex'>
                                             {!onlyView && 'Edit'} Form Rule: {stepsData.name}
                                        </h1>
                                   </div>
                                   {!onlyView && (
                                        <div className='form-edit-lookup-button'>
                                             <div className='form-edit-lookup-button d-flex justify-content-end'>
                                                  <div className='form-edit-lookup-button-child'>
                                                       <CButton
                                                            onClick={() => setDeleteRuleModal(true)}
                                                            className={`${!flexibleModal.showLv2 && 'mr-3'} d-inline-block text-uppercase btn-outline-secondary text-dark`}
                                                            disabled={deleteLoading}
                                                       >
                                                            Delete Rule
                                                       </CButton>
                                                       {!flexibleModal.showLv2 && (
                                                            <CButton
                                                                 color='primary'
                                                                 onClick={() => handleClickEditButton(stepsData.id)}
                                                                 className='d-inline-block text-uppercase'
                                                            >
                                                                 Edit Rule Settings
                                                            </CButton>
                                                       )}
                                                  </div>
                                                  <div>
                                                       {stepsData.hasOldVersion && (
                                                            <CButton color='primary' onClick={() => setRevertModal(true)} className='mr-3 d-inline-block text-uppercase'>
                                                                 Revert
                                                            </CButton>
                                                       )}
                                                       <CButton color='success' type='submit' className='d-inline-block text-uppercase' disabled={btnSaveStatus}>
                                                            Save Changes
                                                       </CButton>
                                                  </div>
                                             </div>
                                        </div>
                                   )}
                              </CCol>
                              <CCol md='12' className='form-edit-lookup-description'>
                                   {conditions?.length > 0 && conditions[0].length > 0 && (
                                        <p>
                                             Manage variable values based on the conditions you selected when building this rule. The first <b>{conditions[0].length}</b>{' '}
                                             columns of this table represent the conditions you selected in the rule settings. The other <b>{1}</b> columns each represent
                                             a variable value. Define condition values and their subsequent variable values.
                                        </p>
                                   )}
                              </CCol>
                         </CRow>
                    )}
                    {variant === 'crawl-block' && (
                         <>
                              <div className='form-edit-lookup-row'>
                                   <div className='form-edit-lookup-button'>
                                        <div className='form-edit-lookup-button d-flex justify-content-end'>
                                             {!isCreateMode && (
                                                  <div className='form-edit-lookup-button-child'>
                                                       <CButton
                                                            onClick={() => setDeleteRuleModal(true)}
                                                            className={`${!flexibleModal.showLv2 && 'mr-3'} d-inline-block text-uppercase btn-outline-secondary text-dark`}
                                                            disabled={deleteLoading}
                                                       >
                                                            Delete Rule
                                                       </CButton>
                                                  </div>
                                             )}
                                             <div>
                                                  {stepsData?.hasOldVersion && !isCreateMode && (
                                                       <CButton color='primary' onClick={() => setRevertModal(true)} className='mr-3 d-inline-block text-uppercase'>
                                                            Revert
                                                       </CButton>
                                                  )}
                                                  <CButton color='success' type='submit' className='d-inline-block text-uppercase' disabled={btnSaveStatus}>
                                                       Save Changes
                                                  </CButton>
                                             </div>
                                        </div>
                                   </div>
                              </div>
                              <div className='form-edit-lookup-description'>
                                   {conditions?.[0]?.length > 0 && (
                                        <p>
                                             Manage variable values based on the conditions you selected when building this rule. The first <b>{conditions[0].length}</b>{' '}
                                             columns of this table represent the conditions you selected in the rule settings. The other <b>{1}</b> columns each represent
                                             a variable value. Define condition values and their subsequent variable values.
                                        </p>
                                   )}
                              </div>
                         </>
                    )}

                    <div className='table-wrapper mb-3' onScroll={handleScrollTableWrapper}>
                         <DragDropContext onDragEnd={onDragEnd}>
                              <Droppable droppableId='table'>
                                   {(provided) => (
                                        <>
                                             <table ref={provided.innerRef} className={`table lookup-table lookup-table-init${onlyView ? ' table-only-view' : ''}`}>
                                                  {fetchLoading ? (
                                                       <tbody>
                                                            <tr>
                                                                 <td>
                                                                      <CenterSpinner />
                                                                 </td>
                                                            </tr>
                                                       </tbody>
                                                  ) : (
                                                       <>
                                                            {conditions?.length > 0 ? (
                                                                 <>
                                                                      <thead>
                                                                           <tr className='rule-flow'>
                                                                                <td colSpan={condColSpan}>If these conditions are met</td>
                                                                                {isRuleEdit && <td colSpan={2}>Send these values to my data layer</td>}
                                                                           </tr>
                                                                           <RuleTableContext.Provider value={headerRowContext}>
                                                                                <TableHeaderRow isCreateMode={isCreateMode} onlyView={onlyView} />
                                                                           </RuleTableContext.Provider>
                                                                      </thead>
                                                                      <tbody>
                                                                           <RuleTableContext.Provider value={bodyRowContext}>
                                                                                <TableBodyRows
                                                                                     isCreateMode={isCreateMode}
                                                                                     onlyView={onlyView}
                                                                                     innerRef={provided.innerRef}
                                                                                     {...provided.droppableProps}
                                                                                />
                                                                                {provided.placeholder}
                                                                           </RuleTableContext.Provider>
                                                                      </tbody>
                                                                 </>
                                                            ) : (
                                                                 <p className='pt-2'>There are no conditions.</p>
                                                            )}
                                                       </>
                                                  )}
                                             </table>
                                             <table className='table lookup-table lookup-table-sticky'>
                                                  <thead>
                                                       <tr className='rule-flow'>
                                                            <td colSpan={condColSpan}>If these conditions are met</td>
                                                            {isRuleEdit && <td colSpan={2}>Send these values to my data layer</td>}
                                                       </tr>
                                                       {conditions?.length > 0 && (
                                                            <RuleTableContext.Provider value={headerRowContext}>
                                                                 <TableHeaderRow isCreateMode={isCreateMode} onlyView={onlyView} />
                                                            </RuleTableContext.Provider>
                                                       )}
                                                  </thead>
                                             </table>
                                        </>
                                   )}
                              </Droppable>
                         </DragDropContext>
                    </div>

                    <div className={`${showCheatSheet ? 'add-margin-cheat-sheet' : ''} form-edit-lookup-row`}>
                         {!onlyView && (
                              <div className='add-row-button mb-4 d-flex align-items-center'>
                                   <div className='add-row-button-child d-flex'>
                                        <CButton className='btn-add-row' onClick={() => handleAddRow(1)}>
                                             <CIcon icon='iconAddField' className='icon-add' />
                                             <CLabel className='add-row mb-0'>Add Row</CLabel>
                                        </CButton>
                                        <CButton className='btn-add-row' onClick={() => handleAddRow(5)}>
                                             <CIcon icon='iconAddField' className='icon-add' />
                                             <CLabel className='add-row mb-0'>Add 5 Rows</CLabel>
                                        </CButton>
                                   </div>
                                   <div className='d-flex align-items-center'>
                                        <div className='regex-wrapper'>
                                             <div className='regex-recommemd'>
                                                  <CIcon icon='cil-chevron-double-down' height={14} />
                                                  <button type='button' onClick={handleClickCheatSheet}>
                                                       RegEx Cheatsheet
                                                  </button>
                                             </div>
                                             <ul ref={wrapperRef} className={showCheatSheet ? '' : 'hidden'}>
                                                  {REGEX_PATTERNS.map((el, index) => (
                                                       <li key={index}>
                                                            <span>{el.PATTERN}</span>
                                                            <span>{el.DESCRIPTION}</span>
                                                       </li>
                                                  ))}
                                             </ul>
                                        </div>
                                        {conditions?.length > 0 && conditions[0].length > 0 && (
                                             <RuleTableContext.Provider value={importExportContext}>
                                                  <ImportExportTable onlyView={onlyView} />
                                             </RuleTableContext.Provider>
                                        )}
                                   </div>
                              </div>
                         )}

                         {!onlyView && (
                              <div className='mb-3 form-edit-lookup-button text-right d-flex justify-content-end'>
                                   {!isCreateMode && (
                                        <div className='form-edit-lookup-button-child'>
                                             <CButton
                                                  onClick={() => setDeleteRuleModal(true)}
                                                  className={`${!flexibleModal.showLv2 && 'mr-3'} d-inline-block text-uppercase btn-outline-secondary text-dark`}
                                                  disabled={deleteLoading}
                                             >
                                                  Delete Rule
                                             </CButton>
                                             {isRuleEdit && !flexibleModal.showLv2 && (
                                                  <CButton color='primary' onClick={() => handleClickEditButton(stepsData.id)} className='d-inline-block text-uppercase'>
                                                       Edit Rule Settings
                                                  </CButton>
                                             )}
                                        </div>
                                   )}
                                   <div>
                                        {stepsData?.hasOldVersion && !isCreateMode && (
                                             <CButton color='primary' onClick={() => setRevertModal(true)} className='mr-3 d-inline-block text-uppercase'>
                                                  Revert
                                             </CButton>
                                        )}
                                        <CButton color='success' type='submit' className='d-inline-block text-uppercase' disabled={btnSaveStatus}>
                                             Save Changes
                                        </CButton>
                                   </div>
                              </div>
                         )}
                    </div>
               </CForm>

               <ConfirmRemovePopup show={deleteRuleModal} onAccept={handleDelete} onClose={() => setDeleteRuleModal(false)} isLoading={deleteLoading}>
                    <p className='mb-4'>
                         You are about to delete the rule <strong>"{stepsData?.name}"</strong>. Please note{' '}
                         <span className='text-danger'>this action is irreversible</span>.
                    </p>
               </ConfirmRemovePopup>
               <RemovePopup show={removeRowModal.show} onAccept={confirmRemoveRow} onClose={() => setRemoveRowModal({ show: false, index: -1 })} loading={deleteLoading}>
                    <p>Are you sure to remove this row?</p>
               </RemovePopup>
               <ConfirmSaveChange
                    show={saveTableModal}
                    onAccept={onAcceptSaveModal}
                    onClose={() => setSaveTableModal(false)}
                    title='Save Your Changes?'
                    isLoading={saveLoading}
               >
                    It looks like you have made changes to this lookup table but have not saved them. Would you like to save the changes before navigating away?
               </ConfirmSaveChange>
               <ConfirmSaveChange show={revertModal} onAccept={handleReverting} onClose={() => setRevertModal(false)} title='Revert This Rule?' isLoading={saveLoading}>
                    This rule will be reverted to the last version. Would you like to revert it?
               </ConfirmSaveChange>
               <LeaveComponentChangePopup
                    show={leaveComponentModal || unsavedLookupTableModal.show}
                    onAccept={handleAcceptLeaveComponent}
                    onClose={handleCloseLeaveComponent}
                    title='You Have Unsaved Changes'
                    btnAbandon={btnAbandon ? <span className='dots-waiting'>Waiting</span> : 'Abandon My Changes & Leave'}
               >
                    You haven't saved the changes you started making to this lookup table. If you navigate away, you will lose the changes. What do you want to do?
               </LeaveComponentChangePopup>
          </>
     );
};

FormRuleTableBase.defaultProps = {
     isCreateMode: false,
     fetchLoading: false,
     extraBodyContext: {},
     extraImportContext: {},
     btnSaveStatusInitial: true,
     scrollThreshold: 15,
};

FormRuleTableBase.propTypes = {
     variant: PropTypes.oneOf(['crawl-block', 'rule-edit']).isRequired,
     stepsData: PropTypes.object,
     setStepsData: PropTypes.func,
     initialStepsData: PropTypes.object,
     isCreateMode: PropTypes.bool,
     rulesStateKey: PropTypes.string.isRequired,
     selectedListenerRule: PropTypes.string,
     fetchLoading: PropTypes.bool,
     fetchRule: PropTypes.func,
     validateFn: PropTypes.func.isRequired,
     onRevertSuccess: PropTypes.func.isRequired,
     TableHeaderRow: PropTypes.elementType.isRequired,
     TableBodyRows: PropTypes.elementType.isRequired,
     ImportExportTable: PropTypes.elementType.isRequired,
     extraBodyContext: PropTypes.object,
     extraImportContext: PropTypes.object,
     btnSaveStatusInitial: PropTypes.bool,
     scrollThreshold: PropTypes.number,
};

export default FormRuleTableBase;
